/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import { Tooltip } from 'react-tooltip'
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { userlogin } from "ReduxReducers/loginReducers";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { googleSigin, login } from "utils/authApi";
import { getSesstionDataByUserID, showResMsg } from "utils/generic";
import validator from "validator";
import bgImage from "../../../assets/images/download.jpg";
import LoadingModal from "../../../components/LoadingModel/loadingModal";

const errMsg = {
  color: `red`,
  fontSize: `14px`,
};
function Basic({ ...props }) {
  const navigate = useNavigate();
  const [checkLogin, setCheckLogin] = useState(false);
  const [emailErr, setemailErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState('');
  const [passwordErr, setPasswordErr] = useState(false);
  const [passwordErrMsg, setPasswordErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signup, setSignup] = useState(false);
  const [password, setPassword] = useState(false);
  const [password1, setPassword1] = useState(false);
  const [phoneNumberErr, setPhoneNumberErr] = useState(false);
  const [loginMobile, setloginMobile] = useState(false)

  const dispatch = useDispatch();
  const [values, setValues] = React.useState({
    emailAddress: "",
    userPassword: "",
    phoneNumber: "",
    onlyPhoneNumber: ""
  });
  const [emailErr1, setemailErr1] = useState(false);
  let mandateFlag = false;
  useEffect(() => {
    loadData();
    dispatch(loadingAction(false))
    sessionStorage.setItem("LOGIN_ROUTE", "/login")
    sessionStorage.clear("SIGN_DETAILS")
  }, []);
  // const handleChange = (name) => (event) => {
  //   setValues({ ...values, [name]: event.target.value });
  // };

  const handleChange = (name) => (event) => {
    const newValue = event.target.value;
    setValues({ ...values, [name]: newValue });
    if (name === "emailAddress") setemailErr(false);
    if (name === "userPassword") setPasswordErr(false);
  };


  const onSuccess = async (res) => {
    const idToken = res.profileObj;

    googleSigin(idToken, (data) => {

    }, dispatch);
    // if (result?.data?.role == 1) {

    // } else if (result?.data?.status === "failure") {

    // }
  };
  const onFailure = (res) => {
    console.log("dsdasdas", res)
    // toast.error(
    //   "Google login canceled or encountered an error",
    //   {
    //     theme: "dark",
    //   },
    //   {
    //     position: toast.POSITION.TOP_CENTER,
    //   },
    //   { autoClose: 1000 }
    // );
  };

  const handleFacebookResponse = async (response) => {
    console.log("handleFacebook Response: ", response)
    if (response.accessToken) {
      const accessToken = response.accessToken;

    }

  };
  // const setPhoneValues = (phone, country) => {
  //   values.onlyPhoneNumber = phone.slice(country.dialCode.length);
  //   console.log("phone", phone.slice(country.dialCode.length));
  //   values.phoneNumber = phone.slice(country.dialCode.length);
  //   values.phoneNumber = phone
  //   values.countryCode = "+" + country.dialCode;
  // };
  // const setPhoneValues = (phone, country) => {
  //   values.onlyPhoneNumber = phone.toString().slice(country.dialCode.length + 1).trim();
  //   values.phoneNumber = phone;
  //   values.countryCode = "+" + country.dialCode;
  // };
  const setPhoneValues = (phone, country) => {
    const dialCode = country.dialCode;

    // Remove country code safely
    const onlyNumber = phone.replace(`+${dialCode}`, "").trim();

    setValues(prev => ({
      ...prev,
      phoneNumber: phone,
      onlyPhoneNumber: onlyNumber,
      countryCode: `+${dialCode}`
    }));

    // Clear error once user starts typing
    if (onlyNumber.length > 0) {
      setPhoneNumberErr(false);

    }
  };
  const clearErrorStates = () => {
    setPasswordErr(false);
    setPhoneNumberErr(false);
    setemailErr(false);
    setPasswordErrMsg("");
    setemailTitleErr("")
  }
  const checkLoginCredentilas = async () => {
    try {
      localStorage.emailAddress = "";
      localStorage.userPassword = "";
      localStorage.loginChecked = false;
      mandateFlag = false;

      if (loginMobile) {

        if (values.onlyPhoneNumber.toString().trim() !== "") {
          if (
            values.phoneNumber.toString().trim() === "" ||
            values.phoneNumber.toString().trim().length < 12
          ) {
            setPhoneNumberErr(true);
            mandateFlag = true;
          } else {
            setPhoneNumberErr(false);
            values.mobileNumberExist = true;
          }
        } else {
          setPhoneNumberErr(true);
          mandateFlag = true
        }
      } else {
        if (values.emailAddress.toString().trim() === "") {
          setemailErr(true);
          setemailTitleErr("Email Address can't be blank");
          setemailErr1(false);
          mandateFlag = true;
        } else setemailErr(false);

        if (values.emailAddress.toString().trim() !== "") {
          if (!validator.isEmail(values.emailAddress)) {
            setemailErr(true);
            setemailTitleErr("Enter valid Email Address.");
            mandateFlag = true;
            setemailErr1(false);
          } else setemailErr(false);
        }

      }
      if (!values.userPassword) {
        setPasswordErr(true);
        setPasswordErrMsg("Password can't be blank");
        mandateFlag = true;
      }
      // else if (values.userPassword.toString().trim().length < 8) {
      //   setPasswordErr(true);
      //   setPasswordErrMsg("Password should contain atleast 8 characters");
      //   mandateFlag = true;
      // }
      else if (values.userPassword.toString().trim().length < 8 || values.userPassword.toString().trim().length > 20) {
        setPasswordErr(true);
        setPasswordErrMsg("Password should be between 8 to 20 characters");
        mandateFlag = true;
      }
      // } else if (!/[A-Z]/.test(values.userPassword)) {
      //   setPasswordErr(true);
      //   setPasswordErrMsg("Password should contain at least one uppercase letter");
      //   mandateFlag = true;
      // } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.userPassword)) {
      //   setPasswordErr(true);
      //   setPasswordErrMsg("Password should contain at least one special character");
      //   mandateFlag = true;
      else setPasswordErr(false);
      if (mandateFlag) {
        return;
      }

      login(values, async (data) => {

        if (data.Result_Status) {
          if (data.Result_Output?.wizardStatusFlag === 0) {
            navigate(`/wizard/${data.Result_Output.data._id}`)
            return
          }
          let flag = await getSesstionDataByUserID(data.Result_Output.data._id, dispatch);
          if (!flag) {
            sessionStorage.clear();
            navigate("/");
          }
          dispatch(userlogin(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))))
          sessionStorage.setItem("TOKEN", data.Result_Output.token)
          if (data.Result_Output.data.firstTimeUser === 1) {
            sessionStorage.setItem("RESET_PASSWORD", JSON.stringify("false"));
            navigate("/change");
          } else {
            if (values.loginChecked !== false) {
              localStorage.emailAddress = values.emailAddress;
              // localStorage.userPassword = values.userPassword;
              localStorage.loginChecked = values.loginChecked;
            }
            sessionStorage.setItem("THEME_DARK", false);
            let ROLE = JSON.parse(sessionStorage.getItem("ROLE"));
            if (ROLE) {
              sessionStorage.setItem("USER_DETAILS", data.Result_Output.data);
              sessionStorage.setItem("ROLE_NAME", ROLE.roleName);
              if (ROLE.roleName === "Super Admin") {
                window.location.href = "dashboard-su"
              }
              else if (ROLE.roleName === "Warehouse Dashboard") {
                window.location.href = "/warehouseDashboard"
              } else window.location.href = "/dashboard";
            } else {
              dispatch(loadingAction(false));
              showResMsg("Role not found!", 2000, false);
            }
          }
        } else {
          dispatch(loadingAction(false))
          showResMsg(data.Result_Message, 2000, false)
        }

      }, dispatch)
    } catch (error) {
      dispatch(loadingAction(false))
      console.log("Catch in login user=", error);
    }
  };

  const conditions = [
    {
      test: values.userPassword.trim().length >= 8 && values.userPassword.trim().length <= 20,
      message: "Password length should be between 8 to 20 Characters",
    },
    {
      test: /[A-Z]/.test(values.userPassword),
      message: "Atleast 1 Upper case ",
    },
    // {
    //   test: /[a-z]/.test(values.userPassword),
    //   message: "Atleast 1 lower case ",
    // },
    // {
    //   test: /[0-9]/.test(values.userPassword),
    //   message: "Atleast 1 one Number",
    // },
    {
      test: /[!@#$%^&*(),.?":{}|<>]/.test(values.userPassword),
      message: "Atleast 1 special character",
    },
  ];

  async function loadData() {
    if (localStorage.loginChecked && localStorage.emailAddress !== "") {
      setValues({
        emailAddress: localStorage.emailAddress,
        userPassword: localStorage.userPassword,
        loginChecked: localStorage.loginChecked,
      });
      setCheckLogin(localStorage.loginChecked);
    }

    if (localStorage.viewUserID) {
      let flag = await getSesstionDataByUserID(localStorage.viewUserID);
      sessionStorage.setItem("LOGIN_DATETIME", JSON.stringify(new Date()));
      if (flag) {
        window.location.href = "/dashboard";
      } else {
        sessionStorage.clear();
        props.history.push("/");
      }
      localStorage.removeItem("viewUserID");
    }
  }
  const rememberMe = async (event) => {
    setCheckLogin(!checkLogin);
    if (event.target.checked) {
      values.loginChecked = true;
      localStorage.loginChecked = true;
    } else {
      values.loginChecked = false;
      localStorage.loginChecked = false;
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card sx={{ width: 400 }}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={3}>
            <p style={{ fontWeight: "bold", fontSize: "2rem" }}> Invoice & Recover</p>
          </MDTypography>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>

            <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}> {!signup ? <>Login</> : <>Signup</>}  </p>

          </MDTypography>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>

            <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}> {password && <>(OTP Verification)</>} {password1 && <>(Configure Password) </>} </p>

          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              {!loginMobile &&
                <>
                  <MDInput
                    type="email"
                    label="Email Address"
                    fullWidth
                    value={values.emailAddress}
                    inputLabelProps={{ shrink: true }}
                    inputProps={{
                      maxLength: 50
                    }}
                    onChange={handleChange("emailAddress")}
                  />
                  {emailErr ? <p style={errMsg}> {emailTitleErr}</p> : ""}</>
              }
              {loginMobile &&
                <MuiPhoneNumber
                  onlyCountries={["in", "au"]}
                  defaultCountry={"au"}
                  type="text"
                  label="Mobile Number"
                  variant="outlined"
                  inputLabelProps={{ shrink: true }}
                  fullWidth
                  value={values.phoneNumber}
                  onChange={(phone, country) => setPhoneValues(phone, country)}

                />
              }
              <p>{phoneNumberErr ? <span style={errMsg}>Enter valid 10 digit number</span> : ""}</p>


              <MDTypography
                onClick={() => {

                  setloginMobile(!loginMobile)
                  if (loginMobile) {
                    setValues((preValues) => ({
                      ...preValues,
                      onlyPhoneNumber: "",
                      phoneNumber: ""

                    }))

                  } else {
                    setValues((preValues) => ({
                      ...preValues,
                      emailAddress: "",

                    }))

                  }
                }}
                variant="button"
                color="info"
                fontWeight="medium"

                textGradient
              >
                {/* <p style={{ cursor: "pointer" }}> {loginMobile ? <>Login with Email Address</> : <> Login with Mobile Number</>} </p> */}
                <p style={{ cursor: "pointer" }}> {loginMobile ? <>Login with Email Address</> : <> </>} </p>
              </MDTypography>
              {/* 
              {phoneNumberErr ? <span style={errMsg}>Enter valid 10 digit number</span> : ""} */}

            </MDBox>
            <MDBox mb={2}>

              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"} clea
                  value={values.userPassword}
                  inputProps={{
                    maxLength: 30
                  }}
                  onChange={handleChange("userPassword")}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") checkLoginCredentilas();
                  }}
                  data-tooltip-id="passwordTooltip"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        value={values.newPassword}
                        onChange={handleChange("newPassword")}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff onClick={() => setShowPassword(!showPassword)} />
                        ) : (
                          <Visibility onClick={() => setShowPassword(!showPassword)} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
              <Tooltip id="passwordTooltip" place="right" effect="solid" border="1px solid #49a3f1" style={{ backgroundColor: 'white', color: 'black', margin: '0px -20px', borderRadius: '5px', }}>
                <ol style={{ listStyleType: 'none', padding: 0, margin: 0, fontSize: "12px" }}>
                  {conditions.map((condition, index) => (
                    <li key={index} style={{ color: condition.test ? 'green' : 'gray' }}>
                      {condition.message}
                    </li>
                  ))}
                </ol>
              </Tooltip>

              {passwordErr ? <span style={errMsg}> {passwordErrMsg}</span> : ""}
            </MDBox>
            <Grid container>
              <Grid item lg={6}>
                <MDBox display="flex" alignItems="center" ml={-1}>
                  <Switch checked={checkLogin} onChange={rememberMe} />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    // onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Remember Me
                  </MDTypography>
                </MDBox>
              </Grid>

              <Grid item lg={6} textAlign="end">
                <Link to="/reset-pass" className="link">
                  <MDTypography
                    component="a"
                    variant="button"
                    fontWeight="bold"
                    color="info"
                    textGradient
                    style={{ cursor: "pointer" }}
                  >
                    Forgot Password?
                  </MDTypography>
                </Link>
              </Grid>
            </Grid>

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" style={{ fontSize: "14px" }} color="info" fullWidth onClick={checkLoginCredentilas}>
                Login
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <Link to="/authentication/sign-up" className="link">
                  <MDTypography

                    // onClick={() => setSignup(true)}
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    Sign up
                  </MDTypography>
                </Link>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <LoadingModal loading={loading} />
    </BasicLayout>
  );
}

export default Basic;
